export default __webpack_public_path__ + "images/9b5cfcba9fa3555a63d9a9b4e91420fd-music.webp";